import { Component, inject, ViewChild } from '@angular/core';
import { Division } from '../../../models/division';
import { Area } from '../../../models/area';
import { findAreasCatalogAct, findDivisionsCatalogAct } from '../../../store/catalog-offer/catalog-offer.actions';
import { select, Store } from '@ngrx/store';
import { distinctUntilChanged, map } from 'rxjs';
import { FilterBudgetCalculation } from '../../../models/filters/filter-budget-calculation';
import { BudgetCalculationService } from '../../../services/budget-calculation.service';
import { MatExpansionPanel } from '@angular/material/expansion';
import { AlertaService } from '../../../services/alerta.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-budget-calculation',
  standalone: false,
  templateUrl: './budget-calculation.component.html',
  styleUrl: './budget-calculation.component.css'
})
export class BudgetCalculationComponent {

  //@ViewChild('advancedPanel') advancedPanel!: MatExpansionPanel;

  divisions: Division[] = [];
  areas: Area[] = [];
  filterBudgetCalculation: FilterBudgetCalculation = new FilterBudgetCalculation;
  private budgetCalculationService = inject(BudgetCalculationService);
  private alerta = inject(AlertaService);
  router = inject(Router);
  loading: boolean = false;

  ngAfterViewInit() {
    //this.advancedPanel.open();
  }

  ngOnInit(): void {
    this.filterBudgetCalculation = new FilterBudgetCalculation();

    this.catalogOfferStore.dispatch(findDivisionsCatalogAct());
    this.catalogOfferStore.dispatch(findAreasCatalogAct());
  }

  constructor(private catalogOfferStore: Store<{catalogOfferRdc: any}>){
    this.catalogOfferStore.pipe(
          select('catalogOfferRdc'),
          map(state => ({
            divisions: state.divisions,
            areas: state.areas,
          })),
          distinctUntilChanged((prev, curr) =>
            JSON.stringify(prev) === JSON.stringify(curr)
          )
        ).subscribe(({ divisions, areas}) => {
          this.divisions = divisions;
          this.areas = areas;
        });
  }

  executeBudgetCalculation(){
    this.loading = true;
    this.budgetCalculationService.budgetCalculation(this.filterBudgetCalculation).subscribe({
      next: (response) => {
        const fileURL = URL.createObjectURL(response);
        this.loading = false;
        this.alerta.correct("Se realizo el calculo correctamente: ");
        window.open(fileURL, '_blank');

        this.loading = false;
      },
      error: (err) => {
        this.loading = false;
        if(err.status == 400){
          this.alerta.error("Se ha terminado el tiempo de session: ", {detail: err.message});
          this.router.navigate(['/login']);
        }else{
          this.alerta.error("Se ha precentado un error interno: ", {detail: err.message});
        }
      }
    });
  }
}
